let folder = 'technologie'
export const state = () => ({
  meta: null,
  stage: null,
  intro: null,
  ads: null,
  tools: null,
  boxes: null,
  marketingIntelligence: null,
  contact: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  intro(state) {
    return state.intro
  },
  ads(state) {
    return state.ads
  },
  tools(state) {
    return state.tools
  },
  boxes(state) {
    return state.boxes
  },
  marketingIntelligence(state) {
    return state.marketingIntelligence
  },
  contact(state) {
    return state.contact
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setIntro(state, { data }) {
    state.intro = data
  },
  setAds(state, { data }) {
    state.ads = data
  },
  setTools(state, { data }) {
    state.tools = data.tools.filter((tool) => {
      return Object.keys(tool).length > 0
    })
  },
  setBoxes(state, { data }) {
    state.boxes = data
  },
  setMarketingIntelligence(state, { data }) {
    state.marketingIntelligence = data
  },
  setContact(state, { data }) {
    state.contact = data
  }
}
export const actions = {
  getMeta({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/stage.json`)
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getIntro({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/intro.json`)
      .then((res) => {
        commit('setIntro', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getAds({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/ads.json`)
      .then((res) => {
        commit('setAds', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getTools({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/tools.json`)
      .then((res) => {
        commit('setTools', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getBoxes({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/boxes.json`)
      .then((res) => {
        commit('setBoxes', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getMarketingIntelligence({ commit, rootState }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/marketing_intelligence.json`
      )
      .then((res) => {
        commit('setMarketingIntelligence', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContact({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/contact.json`)
      .then((res) => {
        commit('setContact', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
